import React from 'react'
import { SummaryKpi } from '@carbon/icons-react'
import { Stack } from '@carbon/react'
import { Iframe } from './Map.styles'
import { CardComponent, CardRow } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card'
import Typography from '../../../components/Basics/Typography'

/**
 * The Map's Page.
 */
const CanContainer = () => {

    return (
            <Stack gap={3}>
                <CardComponent width="100%" height="100%">
                    <Card $justifyContent='flex-start'>
                        <SummaryKpi size={18} />
                        <Typography className='cds--type-heading-compact-01'>
                            DASHBOARD CAN
                        </Typography>
                    </Card>
                    <CardRow width='inherit'>
                        <Card width='100%' $padding="0">
                            <Iframe title="Monitoring map" src="https://grafana.terrestra.tech/d/dbec2292-1014-42a9-b698-cf99c7aba18e/can?orgId=1&refresh=30s&var-patente=TYRF47&showCategory=Value+options&from=1750962866736&to=1750966466736&kiosk" width="100%" height="100%" />
                        </Card>
                    </CardRow>
                </CardComponent>
            </Stack>
    )
}

export default CanContainer